// c:\azagent\CassieCloud\Vue.Frontends\admin-portal\src\components\views\cookie-module\mixins\navDrawerMixin.js
/**
 * Mixin for handling navigation drawer state and related accordion styling.
 */
export const navDrawerMixin = {
	data () {
		return {
			/**
       * Indicates if the navigation drawer is in its mini-variant (collapsed) state.
       * @type {boolean}
       */
			isNavDrawerCollapsed: false,
			/**
       * ResizeObserver instance to watch for navigation drawer size changes.
       * @type {ResizeObserver | null}
       */
			resizeObserver: null
		}
	},
	computed: {
		/**
     * Generates CSS classes for the accordion based on navigation drawer state.
     * @returns {object}
     */
		accordionClasses () {
			return { 'nav-collapsed': this.isNavDrawerCollapsed }
		}
	},
	methods: {
		/**
     * Sets up a listener for navigation drawer state changes.
     * Observes the navigation drawer element for class changes indicating collapsed/expanded state.
     */
		setupNavDrawerListener () {
			// Ensure DOM is ready before querying elements
			this.$nextTick(() => {
				const navDrawer = document.querySelector('.v-navigation-drawer')
				if (navDrawer) {
					// Initial state check
					this.isNavDrawerCollapsed = navDrawer.classList.contains('v-navigation-drawer--mini-variant')

					// Use ResizeObserver to watch for width changes, which often correlate with class changes for mini-variant
					this.resizeObserver = new ResizeObserver(() => {
						this.isNavDrawerCollapsed = navDrawer.classList.contains('v-navigation-drawer--mini-variant')
					})
					this.resizeObserver.observe(navDrawer)
				} else {
					console.warn('Navigation drawer element not found for ResizeObserver setup.')
				}
			})
		},
		/**
     * Gets the current width of the navigation drawer.
     * This is primarily for informational purposes as CSS typically handles the visual adjustments.
     * @returns {number} The width of the navigation drawer (e.g., 80 for collapsed, 260 for expanded).
     */
		getNavDrawerWidth () {
			return this.isNavDrawerCollapsed ? 80 : 260 // Example widths
		}
	},
	/**
   * Called when the component is mounted. Sets up the navigation drawer listener.
   */
	mounted () {
		this.setupNavDrawerListener()
	},
	/**
   * Called before the component is destroyed. Cleans up the ResizeObserver.
   */
	beforeDestroy () {
		if (this.resizeObserver) {
			this.resizeObserver.disconnect()
			this.resizeObserver = null // Help with garbage collection
		}
	}
}
